import React, { useState } from 'react';

/**
 * MaskedAadhaarInput — Aadhaar entry masked by default (browser password masking) with a
 * Show/Hide toggle. Drop-in wrapper around a normal <input>: it forwards the caller's
 * `value`/`onChange` unchanged, so all existing formatting/validation stays put — only the
 * rendered characters are hidden. Used across Registration + the ABHA create/verify flows.
 */
export default function MaskedAadhaarInput({
  value,
  onChange,
  placeholder,
  style,
  inputMode = 'numeric',
  maxLength,
  autoFocus = false,
  disabled = false,
  isDark = false,
}) {
  const [show, setShow] = useState(false);

  return (
    <div style={{ position: 'relative' }}>
      <input
        type={show ? 'text' : 'password'}
        inputMode={inputMode}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        maxLength={maxLength}
        autoFocus={autoFocus}
        disabled={disabled}
        autoComplete="off"
        style={{
          ...style,
          paddingRight: '4.25rem',
          ...(disabled ? { opacity: 0.75, cursor: 'not-allowed', background: isDark ? 'rgba(255,255,255,0.03)' : '#f1f5f9' } : {}),
        }}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? 'Hide Aadhaar number' : 'Show Aadhaar number'}
        style={{
          position: 'absolute', right: '0.5rem', top: '50%', transform: 'translateY(-50%)',
          padding: '0.25rem 0.55rem', borderRadius: '0.375rem', cursor: 'pointer',
          fontSize: '0.75rem', fontWeight: 600, lineHeight: 1,
          background: isDark ? '#334155' : '#f1f5f9',
          border: `1px solid ${isDark ? '#475569' : '#cbd5e1'}`,
          color: isDark ? '#e2e8f0' : '#475569',
        }}
      >
        {show ? '🙈 Hide' : '👁 Show'}
      </button>
    </div>
  );
}
